import { PlaceholderProps, components } from "react-select";
import { TAssertionSelectDefaultOption } from "../../../AssertionSentences.types";
import "./Placeholder.styles.scss";

type SelectPlaceholderProps<
  Option extends TAssertionSelectDefaultOption = TAssertionSelectDefaultOption
> = {
  placeholder: string;
} & PlaceholderProps<Option, false>;

export const Placeholder = <
  Option extends TAssertionSelectDefaultOption = TAssertionSelectDefaultOption
>(
  props: SelectPlaceholderProps<Option>
): JSX.Element => {
  const { placeholder } = props;

  return (
    <components.Placeholder
      {...props}
      className="nb-interactive-true-or-false-assertion-select-placeholder"
    >
      {placeholder ? placeholder : props.children}
    </components.Placeholder>
  );
};
